import React from 'react';
import { Text, Card } from '@smarterservices/smarter-ui';
import { List } from '@instructure/ui';
import { getStore } from '../../../stores/StoreContext';
import LabelAndText from '../../Common/LabelAndText';
import CONSTANTS from '../../../config/constants';
const CourseDetails = (props) => {
  const ExamSession = getStore('examSessionStore');

  return (
    <Card {...props}>
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            General Details
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        <List isUnstyled itemSpacing={CONSTANTS.STYLES.CARD_ITEM_SPACING}>
          <List.Item>
            <LabelAndText label="Account" text={ExamSession.sessionData?.account?.name || 'N/A'} />
          </List.Item>
          <List.Item>
            <LabelAndText label="Course" text={ExamSession.courseData?.title || 'N/A'} />
          </List.Item>
          <List.Item>
            <LabelAndText label="Course Code" text={ExamSession.courseData?.code || 'N/A'} />
          </List.Item>
          <List.Item>
            <LabelAndText
              label="Instructor"
              text={`${ExamSession.courseData?.instructor?.firstName || ''} ${ExamSession.courseData?.instructor?.lastName || ''}`.trim() || 'N/A'}
            />
          </List.Item>
        </List>
      </Card.Body>
    </Card>
  );
};

export default CourseDetails;
